module.exports = __webpack_public_path__ + "static/img/md.9701b2d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/md.png
// module id = O0A5
// module chunks = 128